import React from 'react';
import styled from 'styled-components';
import { colors } from '@nauto/uikit/dist/styles';
import { Icon, IconName } from '@nauto/uikit/dist/atoms/icons';
import { Link } from 'react-router-dom';

export interface Props {
  icon: IconName;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  label: string;
  color?: string;
  link?: string;
  'data-testid'?: string;
}

export class ControlBarButton extends React.Component<Props> {
  public render() {
    const {
      className,
      disabled,
      icon,
      onClick,
      link,
      label,
      color,
    } = this.props;

    const content = (
      <button
        data-testid={this.props['data-testid'] || 'control-bar-button'}
        className={`${disabled ? 'disabled' : ''}`}
        disabled={disabled}
        onClick={onClick}
      >
        <Icon
          className="button-icon"
          baseColor={color || colors.grey900}
          icon={icon}
          size="md"
        />
        {label}
      </button>
    );

    return link ? (
      <Link className={className} to={link}>
        {content}
      </Link>
    ) : (
      <div className={className}> {content}</div>
    );
  }
}

export default styled(ControlBarButton)`
  button {
    color: ${colors.black};
    padding: 0; /* Override */
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-right: 1rem;
    .button-icon {
      margin-right: 0.5rem;
    }
    &:hover:not(.disabled) {
      svg * {
        fill: ${colors.brand};
      }
      color: ${colors.brand};
    }
    &[disabled],
    &.disabled {
      &,
      &:hover {
        color: ${colors.grey300};
        cursor: not-allowed;
        fill: currentcolor;
      }
    }
  }
`;
